import React from 'react';

const NotFound = () => {
    return(
        <div>
            Movie
        </div>
    )
}

export default NotFound;